import * as index from '@syncfusion/ej2-lineargauge';
index.LinearGauge.Inject( index.GaugeTooltip,index.Annotations,index.Print,index.PdfExport,index.ImageExport,index.Gradient);
export * from '@syncfusion/ej2-lineargauge';
